import React, { Component } from "react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Utils from "../../utils";
import contractAddress from "../Contract";

import cons from "../../cons.js";

export default class MyOffice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      direccion: "",
      link: "Make a deposit to get your own referral LINK",
      registered: false,
      balanceRef: 0,
      totalRef: 0,
      invested: 0,
      paidAt: 0,
      my: 0,
      withdrawn: 0,
      precioH2O: 0,
      valueH2O: 0,
      valueUSDT: 0

    };

    this.Investors = this.Investors.bind(this);
    this.Link = this.Link.bind(this);
    this.withdraw = this.withdraw.bind(this);

    this.rateH2O = this.rateH2O.bind(this);
    this.handleChangeH2O = this.handleChangeH2O.bind(this);
    this.handleChangeUSDT = this.handleChangeUSDT.bind(this);
  }

  handleChangeH2O(event) {
    this.setState({valueH2O: event.target.value});
  }

  handleChangeUSDT(event) {
    this.setState({valueUSDT: event.target.value});
  }

  async componentDidMount() {
    await Utils.setContract(window.tronWeb, contractAddress);
    setInterval(() => this.Investors(),1*5000);
    setInterval(() => this.Link(),1*5000);
  };

  async rateH2O(){
    var proxyUrl = cons.proxy;
    var apiUrl = cons.PRE;
    const response = await fetch(proxyUrl+apiUrl)
    .catch(error =>{console.error(error)})
    const json = await response.json();

    return json.Data.precio;

  };

  async Link() {
    const {registered} = this.state;
    if(registered){

      let loc = document.location.href;
      if(loc.indexOf('?')>0){
        loc = loc.split('?')[0]
      }
      let mydireccion = await window.tronWeb.trx.getAccount();
      mydireccion = window.tronWeb.address.fromHex(mydireccion.address)
      mydireccion = loc+'?ref='+mydireccion;
      this.setState({
        link: mydireccion,
      });
    }else{
      this.setState({
        link: "Make a deposit to create your own referral LINK",
      });
    }
  }


  async Investors() {

    let direccion = await window.tronWeb.trx.getAccount();
    let esto = await Utils.contract.investors(direccion.address).call();
    let My = await Utils.contract.MYwithdrawable().call();
    
    var tronUSDT = await window.tronWeb;
    var contractUSDT = await tronUSDT.contract().at(cons.USDT);
    var decimales = await contractUSDT.decimals().call();

    var precioH2O = await this.rateH2O();

    this.setState({
      direccion: window.tronWeb.address.fromHex(direccion.address),
      registered: esto.registered,
      balanceRef: parseInt(esto.balanceRef._hex)/10**decimales,
      totalRef: parseInt(esto.totalRef._hex)/10**decimales,
      invested: parseInt(esto.invested._hex)/10**decimales,
      paidAt: parseInt(esto.paidAt._hex)/10**decimales,
      my: parseInt(My.amount._hex)/10**decimales,
      withdrawn: parseInt(esto.withdrawn._hex)/10**decimales,
      precioH2O: precioH2O
    });

  };

  async withdraw(){
    const { balanceRef, my } = this.state;

    var available = (balanceRef+my);
    available = available.toFixed(8);
    available = parseFloat(available);

    var tronUSDT = await window.tronWeb;
    var contractUSDT = await tronUSDT.contract().at(cons.USDT);

    var decimales = await contractUSDT.decimals().call();

    var MIN_RETIRO = await Utils.contract.MIN_RETIRO().call();
    MIN_RETIRO = parseInt(MIN_RETIRO._hex)/10**decimales;

    var MAX_RETIRO = await Utils.contract.MAX_RETIRO().call();
    MAX_RETIRO = parseInt(MAX_RETIRO._hex)/10**decimales;


    if ( available < MAX_RETIRO && available > MIN_RETIRO ){
      await Utils.contract.withdraw().send();
    }else{
      if (available > MAX_RETIRO) {
        window.alert("Please contact WATER H2O technical support");
      }
      if (available < MIN_RETIRO) {
        window.alert("The minimum to withdrawal amount is: "+(MIN_RETIRO)+" H2O");
      }
    }
  };


  render() {
    var { balanceRef, totalRef, invested,  withdrawn , my, direccion, link} = this.state;

    var available = (balanceRef+my);
    available = available.toFixed(8);
    available = parseFloat(available);

    balanceRef = balanceRef.toFixed(8);
    balanceRef = parseFloat(balanceRef);

    totalRef = totalRef.toFixed(8);
    totalRef = parseFloat(totalRef);

    invested = invested.toFixed(8);
    invested = parseFloat(invested);

    withdrawn = withdrawn.toFixed(8);
    withdrawn = parseFloat(withdrawn);

    my = my.toFixed(8);
    my = parseFloat(my);

    var imageUSDT = "https://coin.top/production/logo/usdtlogo.png";
    var imageH2O = "https://coin.top/production/upload/logo/TDTpScxGqJMsiM2f7LeV3kc3rL2gHhMMEd.png";

    return (
 <div className="col-12">
          <div className="d-grid gap-3"  >
         <header style={{'textAlign': 'center'}} className="section-title">
          <h3 className="darkblue">Your Wallet</h3></header>
         
          <span ><strong>{direccion}</strong></span>
          <h4>Referral Link:</h4>
          <h6><a className="darkblue" href={link}><strong>{link}</strong></a> <br /><br />
          <CopyToClipboard text={link}>
            <button type="button"  className="btn btn-success">COPY LINK</button>
          </CopyToClipboard>
          </h6>
          <br />
         </div>
  
     
       <div  className="d-grid gap-3 flex-1" style={{'background': 'white'}}>
   
       <p>&nbsp; </p>
       <h3 className="blue">Your Investment</h3> 
      <p >Total Invested: &nbsp; 
         <span><a href="#m">{invested} H2O</a></span> (${(this.state.invested*this.state.precioH2O).toLocaleString("en-US")})
      </p>
      <p >Total Withdrawn: &nbsp; 
         <span><a href="#m">{withdrawn} H2O</a></span> (${(this.state.withdrawn*this.state.precioH2O).toLocaleString("en-US")})
      </p>
      <p>Referral Earnings: &nbsp; 
         <span><a href="#m">{totalRef} H2O</a></span> (${(this.state.totalRef*this.state.precioH2O).toLocaleString("en-US")})
      </p>
      <p >Refferal Balance: &nbsp; 
         <span><a href="#m">{balanceRef} H2O</a></span> (${(this.state.balanceRef*this.state.precioH2O).toLocaleString("en-US")})
      </p>
      <p>Existing Balance: &nbsp; 
         <span><a href="#m">{my} H2O</a></span> (${(this.state.my*this.state.precioH2O).toLocaleString("en-US")})
      </p>
      <p>Eligable To Withdraw: &nbsp; 
      <span><a href="#m">{available} H2O</a></span> (${(available*this.state.precioH2O).toLocaleString("en-US")})
      </p>
      
        
      
      
       <button type="button"  className="btn btn-success" onClick={() => this.withdraw()}>WIthdraw All</button>
           <p> </p>
    </div>
</div>
    );
  }
}
